module.exports = __webpack_public_path__ + "static/fence-contractor-c691c8859ad5af7b3ff573d9e426fb2e.jpg";